import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const MentionsLegales = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen pt-24 pb-16 bg-slate-50" data-testid="mentions-legales-page">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="font-heading font-bold text-3xl md:text-4xl text-slate-900 mb-8">
          {language === 'fr' ? 'Mentions Légales' : 'Legal Notice'}
        </h1>

        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              1. Éditeur du site
            </h2>
            <div className="text-slate-600 space-y-2">
              <p><strong>Raison sociale :</strong> Tannou (SASU en cours de constitution)</p>
              <p><strong>Forme juridique :</strong> Société par Actions Simplifiée Unipersonnelle (SASU) - en cours de constitution</p>
              <p><strong>Siège social :</strong> [Adresse à compléter]</p>
              <p><strong>Capital social :</strong> [Montant à compléter] €</p>
              <p><strong>RCS :</strong> [Numéro à compléter]</p>
              <p><strong>SIRET :</strong> en cours d'attribution</p>
              <p><strong>TVA Intracommunautaire :</strong> [Numéro à compléter]</p>
              <p><strong>Email :</strong> contact@proftoutenun.com</p>
              <p><strong>Téléphone :</strong> [Numéro à compléter]</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              2. Directeur de la publication
            </h2>
            <p className="text-slate-600">
              Le directeur de la publication est [Nom à compléter], en qualité de [Fonction].
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              3. Hébergeur
            </h2>
            <div className="text-slate-600 space-y-2">
              <p><strong>Raison sociale :</strong> Emergent Agent</p>
              <p><strong>Adresse :</strong> [Adresse de l'hébergeur]</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              4. Propriété intellectuelle
            </h2>
            <p className="text-slate-600">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels, etc.) 
              est la propriété exclusive de TANNOU ou de ses partenaires et est protégé par les lois françaises 
              et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation, 
              modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le 
              moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de TANNOU.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              5. Protection des données personnelles
            </h2>
            <p className="text-slate-600">
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique 
              et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition 
              aux données personnelles vous concernant. Pour exercer ces droits, vous pouvez nous contacter 
              à l'adresse email : contact@proftoutenun.com
            </p>
            <div className="mt-4 text-slate-600">
              <p><strong>Finalités du traitement :</strong></p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Gestion des demandes de contact et de devis</li>
                <li>Exécution des contrats de prestation</li>
                <li>Envoi de newsletters (avec consentement)</li>
                <li>Amélioration de nos services</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              6. Cookies
            </h2>
            <p className="text-slate-600">
              Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. 
              En continuant à naviguer sur ce site, vous acceptez l'utilisation de cookies. Vous pouvez 
              configurer votre navigateur pour refuser les cookies.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              7. Limitation de responsabilité
            </h2>
            <p className="text-slate-600">
              TANNOU ne saurait être tenu responsable des dommages directs ou indirects causés au matériel 
              de l'utilisateur lors de l'accès au site, résultant soit de l'utilisation d'un matériel ne 
              répondant pas aux spécifications techniques requises, soit de l'apparition d'un bug ou d'une 
              incompatibilité. TANNOU ne pourra également être tenu responsable des dommages indirects 
              consécutifs à l'utilisation du site.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              8. Droit applicable
            </h2>
            <p className="text-slate-600">
              Les présentes mentions légales sont régies par le droit français. En cas de litige, 
              les tribunaux français seront seuls compétents.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              9. Contact
            </h2>
            <p className="text-slate-600">
              Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter 
              à l'adresse suivante : contact@proftoutenun.com
            </p>
          </section>

          <p className="text-slate-400 text-sm pt-4 border-t">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>
    </div>
  );
};
